export const GOOGLE_SITE_KEY = '6LddkfIsAAAAAG_JcOVuSghUj2wHDT7aVhTQuWlM';
